/* eslint-disable @typescript-eslint/no-explicit-any */
import api from "./api";
import type { supplierMutate } from "../types/suppliers";

const handleCatch = (error: any) => {
  if (error.code === "DATABASE_ERROR" && error?.details?.length > 0) {
    error.message = error?.details[0];
  }

  throw error;
};

export const loadAllSuppliers = async (
  search?: string,
  page?: number,
  orderTable?: {
    nome_fantasia?: "ASC" | "DESC";
    estado?: "ASC" | "DESC";
    municipio?: "ASC" | "DESC";
    telefone?: "ASC" | "DESC";
  },
  filter?: {
    estado?: string;
    municipio?: string;
    telefone?: string;
  },
) => {
  try {
    const res = await api.get(`/supplier/loadAllSuppliers/${page}`, {
      params: { search, orderTable, filter },
    });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const getSupplier = async (uid_fornecedor: string) => {
  try {
    const res = await api.get(`/supplier/getSupplier`, {
      params: { uid_fornecedor },
    });

    return res.data.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const registerOrEditSupplier = async (supplierData: supplierMutate) => {
  try {
    const res = await api.post(
      "/supplier/registerOrEditSupplier",
      supplierData,
    );

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const deleteSupplier = async (uid_fornecedor: string) => {
  try {
    const res = await api.post(`/supplier/deleteSupplier/`, { uid_fornecedor });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const loadAllSuppliersPurchases = async (
  search?: string,
  page?: number,
) => {
  try {
    const res = await api.get(`/supplier/loadAllSuppliers/${page || ""}`, {
      params: { search }
    });
    console.log(res);
    
    return res.data.data;
  } catch (error: any) {
    console.error(error);
    
    throw handleCatch(error);
  }
};

export const getIncomingPayments = async (
  uid_fornecedor: string,
  page: number,
  orderTable?: {
    uid_cliente?: "ASC" | "DESC";
    tipo_pagamento?: "ASC" | "DESC";
    date_fina?: "ASC" | "DESC";
    tipo?: "ASC" | "DESC";
    numero_documento?: "ASC" | "DESC";
    date_initial?: "ASC" | "DESC";
    status?: "ASC" | "DESC";
    codigo_estabelecimento?: "ASC" | "DESC";
    descricao?: "ASC" | "DESC";
    conta_financeira?: "ASC" | "DESC";
    valor_parcela?: "ASC" | "DESC";
    parcela?: "ASC" | "DESC";
    data_vencimento?: "ASC" | "DESC";
    data_pagamento?: "ASC" | "DESC";
    uid_centro_custo?: "ASC" | "DESC";
    uid_plano_contas?: "ASC" | "DESC";
  },
) => {
  try {
    const res = await api.get(`/supplier/getIncomingPayments`, {
      params: { uid_fornecedor, orderTable, page },
    });

    return res.data?.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};
